import { render, staticRenderFns } from "./StringFormatter.Trim.vue?vue&type=template&id=6db77c7c&scoped=true"
import script from "./StringFormatter.Trim.vue?vue&type=script&lang=js"
export * from "./StringFormatter.Trim.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.Trim.vue?vue&type=style&index=0&id=6db77c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db77c7c",
  null
  
)

export default component.exports